<template>
  <div class="auth-page p-3">
    <b-row>
      <!-- Sidebar: Tree View -->
      <b-col md="3">
        <b-card no-body class="shadow-sm h-100 border-0">
          <div class="p-3 bg-primary text-white rounded-top">
            <h6 class="mb-0"><b-icon icon="list-ul" class="mr-2"></b-icon> ລາຍການເມນູ</h6>
          </div>
          <div class="tree-container p-2">
            <b-tree-view :data="treeData" :contextMenu="false" @nodeSelect="nodeSelect"></b-tree-view>
          </div>
        </b-card>
      </b-col>

      <!-- Main Content: Permissions Table -->
      <b-col md="9">
        <b-card no-body class="shadow-sm border-0">
          <div class="p-3 border-bottom d-flex align-items-center justify-content-between bg-white rounded-top" v-if="selectedNode">
            <h5 class="mb-0 text-dark font-weight-bold">
              <b-icon icon="shield-lock" variant="primary" class="mr-2"></b-icon>
              ກຳນົດສິດທິ: <span class="text-primary">{{selectedNode.id}} - {{selectedNode.name}}</span>
            </h5>
          </div>

          <div class="p-3">
            <b-table :fields="fields" :items="items" responsive hover striped head-variant="light" class="auth-table border rounded">
              <template #cell(login)="data">
                <div class="text-center action-toggle" @click="oncheck(data.item,'login')">
                  <b-icon v-if="data.item.login==1" icon="check-circle-fill" variant="success" font-scale="1.5"></b-icon>
                  <b-icon v-else icon="x-circle-fill" variant="danger" font-scale="1.5"></b-icon>
                </div>
              </template>

              <template #cell(addnew)="data">
                <div class="text-center action-toggle" @click="oncheck(data.item,'addnew')">
                  <b-icon v-if="data.item.addnew==1" icon="check-circle-fill" variant="success" font-scale="1.5"></b-icon>
                  <b-icon v-else icon="x-circle-fill" variant="danger" font-scale="1.5"></b-icon>
                </div>
              </template>

              <template #cell(edit)="data">
                <div class="text-center action-toggle" @click="oncheck(data.item,'edit')">
                  <b-icon v-if="data.item.edit==1" icon="check-circle-fill" variant="success" font-scale="1.5"></b-icon>
                  <b-icon v-else icon="x-circle-fill" variant="danger" font-scale="1.5"></b-icon>
                </div>
              </template>

              <template #cell(del)="data">
                <div class="text-center action-toggle" @click="oncheck(data.item,'del')">
                  <b-icon v-if="data.item.del==1" icon="check-circle-fill" variant="success" font-scale="1.5"></b-icon>
                  <b-icon v-else icon="x-circle-fill" variant="danger" font-scale="1.5"></b-icon>
                </div>
              </template>
            </b-table>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";

export default {
    filters: {

    },
    methods: {
        bitvalue($level, $Auth) {

            let $mask = Math.pow(2, $level - 1);

            let $fun = $mask & $Auth;

            return $fun;

        },
        nodeSelect(node, isSelected) {
            //console.log('Node ' + node + ' has been ' + (isSelected ? 'selected' : 'deselected'))
            console.log(node.data.login)
            //   let row = this.treeData.find(element => element.menuid == this.selectedNode.id);
            //console.log(row)
            if (isSelected) {
                this.selectedNode = node.data
                axios
                    .get(
                        this.$store.getters.getBaseUrl +
                        "/getAuth/" + this.selectedNode.id, {
                        headers: {
                            'Authorization': 'Bearer ' + this.user.login_hash
                        }
                    }
                    )
                    .then((response) => {
                        // JSON responses are automatically parsed.
                        this.items = response.data;
                        //    console.log(  JSON.parse(response.data))
                    })
            } else if (node.data === this.selectedNode) {
                this.selectedNode = null
            }

        },
        oncheck(item, ac) {
            if (ac == 'login') {
                item.login = !item.login
            }
            if (ac == 'addnew') {
                item.addnew = !item.addnew
            }
            if (ac == 'edit') {
                item.edit = !item.edit
            }

            if (ac == 'del') {
                item.del = !item.del
            }


            // let auth=this.bitvalue(item.level_id,item.login)
            //   console.log(this.items.length)
            let auth = 0
            let auth_add = 0
            let auth_edit = 0
            let auth_del = 0
            for (let $i = 0; $i < this.items.length; $i++) {
                //   console.log(this.items[$i].login )
                if (this.items[$i].login == true) {

                    auth = auth + Math.pow(2, $i)
                }

                if (this.items[$i].addnew == true) {

                    auth_add = auth_add + Math.pow(2, $i)
                }

                if (this.items[$i].edit == true) {

                    auth_edit = auth_edit + Math.pow(2, $i)
                }

                if (this.items[$i].del == true) {

                    auth_del = auth_del + Math.pow(2, $i)
                }

            }
            let rp_data = null;

            let postsdata = {
                table: "menus",
                rows: { "login": auth, addnew: auth_add, edit: auth_edit, del: auth_del },
                pkey: "menuid",
                wharevalue: this.selectedNode._id
            };
            axios
                .post(
                    this.$store.getters.getBaseUrl + "/jsonUpdate",
                    postsdata,
                    {
                        headers: {
                            'Authorization': 'Bearer ' + this.user.login_hash
                        }
                    }
                )
                .then((rep) => {
                    rp_data = rep.data;
                    if (rp_data.msg == "Done") {
                        // alert(rp_data.desc);



                    }
                });
            console.log(auth)
        },


    },
    created() {
        let login = localStorage.getItem("Login");
        this.user = JSON.parse(login);

        axios
            .get(
                this.$store.getters.getBaseUrl +
                "/authtree"
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.treeData = response.data;
                //    console.log(  JSON.parse(response.data))
            })


    },
    data() {
        return {
            count: 0,
            treeData: [],
            item: "",
            selectedNode: '',
            contextMenuItems: [],
            fields: [
                { label: "ລະຫັດ", key: "level_id" },
                { label: "ລະດັບການໃຊ້ງານ", key: "level_desc" },
                { label: "View", key: "login", isActive: true },
                { label: "Add New", key: "addnew" },
                { label: "Edit", key: "edit" },
                { label: "Delete", key: "del" },


            ],
            items: [],


        }
    },

}
</script>

<style scoped>
.auth-page {
    background-color: #f0f2f5;
    min-height: 100vh;
}
.tree-container {
    max-height: 75vh;
    overflow-y: auto;
}
.auth-table ::v-deep th {
    text-align: center;
    vertical-align: middle !important;
    font-weight: bold;
    color: #495057;
}
.action-toggle {
    cursor: pointer;
    display: inline-block;
    transition: transform 0.2s ease;
}
.action-toggle:hover {
    transform: scale(1.2);
}
.card {
    transition: all 0.3s ease;
}
.border {
    border-radius: 8px !important;
}
</style>